export default __webpack_public_path__ + "static/media/vbtc.fee8ea7e.png";